export default "__VITE_ASSET__0FbaRkmM__"